
import axios from 'axios';
import {isOnline, getTrackValueFromUrl, getCookie} from '../util/helper';

let link = isOnline ? {
    require: 'https://gwgp-tkkaggvy9hn.i.bdcloudapi.com'
} : {
    require: 'https://gwgp-g9dwxmpdnkt.i.bdcloudapi.com'
};

export default {
    getBlaPrice(param) {
        return axios.post('/api/bla/products/list', param);
    },
    getVerifyCode(param) {
        return axios.post(`${link.require}/api/tms/reservation/verify`, param);
    },
    // 获取用户的手机号
    getUserPhone() {
        return axios.get('/api/crs/crm/phone');
    },
    getConsultSubmit(param) {
        return axios.post(`${link.require}/api/tms/reservation/save`, param);
    },
    queryStaticData() {
        return axios.get('/api/crs/static/data');
    },
    queryBkpPrice(params) {
        return axios.get('/api/crs/price/bkp', {
            params
        });
    },
    submitOrder(params, options = {}) {
        const trackValue = getTrackValueFromUrl();
        return axios.post('/api/crs/order', {
            ...params,
            linkTrack: trackValue
        }, options);
    },
    // 获取代理记账服务的验证码
    getBkpVerifyCode(params) {
        return axios.post('/api/crs/verification/sms', params);
    },
    // 提交代理记账的需求
    submitBkpDemand(params) {
        const trackValue = getTrackValueFromUrl();
        return axios.post(params.hasLogin ? '/api/crs/demand' : '/api/crs/demand/anonymous', {
            ...params,
            source: trackValue
        });
    },
    // 获取优惠策略
    getCbsPolicy(params) {
        return axios.get('/api/crs/pricing/meta', {params});
    },
    getCbsComregPrice(params) {
        return axios.get('/api/crs/price/comreg', {params});
    },
    getCbsPackagePrice(params) {
        return axios.get('/api/crs/price/package', {params});
    },
    validCbsVerifyCode(params) {
        return axios.post('/api/crs/verification/sms?verify', params);
    },
    // 云上园区-新商品flavor查询
    getCloudParkFlavor(params, options = {}) {
        return axios.get('/api/crs/pricing-flavor', {params}, options);
    },
    // 加入购物车
    addShoppingCart(params, options = {
        headers: {
            csrfToken: getCookie('bce-user-info')
        }
    }) {
        return axios.post('/api/crs/shopping-cart/add', {...params}, options);
    },
    // 判断用户是否实名
    checkUserQualify(params, options = {
        headers: {
            csrfToken: getCookie('bce-user-info')
        }
    }) {
        return axios.post('/api/tms/accounts/real-name/check', params, options);
    }
};